module.exports = __webpack_public_path__ + "img/help32.40abd0b0.png";